/* eslint-disable react/display-name */
import React, {FC, forwardRef, useImperativeHandle} from 'react';

import helpers from '../../utils/helpers';
import AppPopup from './AppPopup';
import useOneModalOnPageAtATime from './useOneModalOnPageAtATime';

interface IProps {
    children?: any;
    className?: string;
    containerClassName?: string;
    onClose?: () => void;
    isClosingBySwipeEnabled?: boolean;
    testId?: string;
    closeButtonAriaLabel?: string;
    overlayClassName?: string;
    ref?: any;
    isCloseByOverlay?: boolean;
}

const PopupFullPage: FC<IProps> = forwardRef((props, popupRef) => {
    const {containerClassName, onClose, ...restProps} = props;
    const onPopupClose = (action?: any) => {
        helpers.runFunction(onClose);
        helpers.runFunction(action);
    };

    const isVisible = useOneModalOnPageAtATime();

    useImperativeHandle(popupRef, () => ({
        onPopupCloseWithAnimation: (action?: () => void) => onPopupClose(action),
    }));

    return isVisible ? (
        <AppPopup
            {...restProps}
            bodyOpenClassName='modal__Body--open'
            overlayClassName='block relative bg-none'
            isOpen
            onRequestClose={onPopupClose}
            className={containerClassName}
        />
    ) : null;
});

export default PopupFullPage;
